<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Update Monthly Staff Attendance</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">

        </div>
      </div>
    </div>
    <div v-if="pagepermission.insertable" class="text-center py-5">
      <a-spin size="large" />
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'UpdateMonthlyAttendanceView',
  data() {
    return {
      permissionCheckSpinning: true,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  beforeMount() {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('staffattendance', 22)
    rc.then(data => {
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
      if (this.pagepermission.insertable) {
        const month = moment().format('YYYY-MM')
        this.$router.replace({ name: 'updatestaffattendancemonthly', params: { month } })
      }
    })
  },
}
</script>

<style>

</style>
